import { allFirmIdsForUser } from "ui/utils/team/teamRole";
import { workspacesEnabled } from "ui/utils/workspace/featureFlag";
import { useLoginState } from "../studioxr/auth/LoginState";

// Whether the user is on any team (designer, admin-only or paused); null until
// permissions resolve. One team per user for now: team members can't create another.
export const useHasTeam = (): boolean | null =>
  useLoginState((s) =>
    !!s.profile?.uid && s.proAccessResolvedUid === s.profile.uid
      ? allFirmIdsForUser(s.permissions).length > 0
      : null,
  );

// Personal "Shared with me" upsell: only for resolved users with no team at all.
export const useShowTeamsUpsell = (): boolean =>
  useHasTeam() === false && workspacesEnabled();
